import { useState, useEffect } from "react"
import { useAddNewExerciseMutation } from "./exercisesApiSlice"
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faDumbbell } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'

const NewExerciseForm = ({ exercisetypes, bodyparts }) => {

    const [addNewExercise, {
        isSuccess,
        isError,
        error
    }] = useAddNewExerciseMutation()

    const navigate = useNavigate()

    const [exercise_name, setExercisename] = useState('')
    const [body_part, setBodypart] = useState(bodyparts[0].id)
    const [exercise_type, setExercisetype] = useState(exercisetypes[0].id)
    const [exercise_details, setExercisedetails] = useState('')
    const [video, setVideo] = useState('')


    useEffect(() => {
        if (isSuccess) {
            setExercisename('')
            setBodypart('')
            setExercisetype('')
            setExercisedetails('')
            setVideo('')

            toast.success("Exercise was Created");
            navigate('/dash/exercises')
        }

        if (isError) {
            toast.error(error?.data?.message);
        }


    }, [isSuccess,navigate, isError, error])

    const onExercisenameChanged = e => setExercisename(e.target.value)
    const onBodypartChanged = e => setBodypart(e.target.value)
    const onExercisetypeChanged= e => setExercisetype(e.target.value)
    const onDetailsChanged= e => setExercisedetails(e.target.value)
    const onVideoChanged= e => setVideo(e.target.value)

    const optionsBP = bodyparts.map(bodypart => {
        return (
            <option key={bodypart.id} value={bodypart.id}>
                {bodypart.bodypart}
            </option >
        )
    })

    const optionsET = exercisetypes.map(exercisetype => {
        return (
            <option key={exercisetype.id} value={exercisetype.id}>
                {exercisetype.exercisetype}
            </option >
        )
    })

    let canSave
    canSave = [exercise_name.length, exercise_details.length].every(Boolean)

    const onSaveExerciseClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewExercise({ exercise_name, body_part, exercise_type, exercise_details, video })
        } else {
            toast.error('All Fields are Required');
        }
    }

    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faDumbbell} style={{fontSize:"30px", marginRight:"5px"}} />New Exercise</h1>
            </header>
            <main>
                <form onSubmit={e => e.preventDefault()}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label" htmlFor="exercise_name">
                                Exercise:
                            </label>
                            <input
                                className="form-control"
                                id="exercise_name"
                                name="exercise_name"
                                type="text"
                                autoComplete="off"
                                value={exercise_name}
                                onChange={onExercisenameChanged}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label" htmlFor="body_part">
                                Region:
                            </label>
                            <select
                                id="body_part"
                                name="body_part"
                                className="form-select"
                                value={body_part}
                                onChange={onBodypartChanged}
                            >
                                {optionsBP}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <label className="form-label" htmlFor="exercise_type">
                                Type:
                            </label>
                            <select
                                id="exercise_type"
                                name="exercise_type"
                                className="form-select"
                                value={exercise_type}
                                onChange={onExercisetypeChanged}
                            >
                                {optionsET}
                            </select>
                        </div>
                    </div>

                    <div className="row mb-3 mt-3">
                        <div className="col-md-12">
                            <label className="form-label" htmlFor="video">
                                Video:
                            </label>
                            <input
                                className="form-control"
                                id="video"
                                name="video"
                                type="text"
                                autoComplete="off"
                                value={video}
                                onChange={onVideoChanged}
                            />
                        </div>
                    </div>

                    <div className="row mb-3 mt-3">
                        <div className="col-md-12">
                            <label className="form-label" htmlFor="exercise_details">
                                Details:
                            </label>
                            <textarea
                                className="form-control"
                                id="exercise_details"
                                rows="5"
                                name="text"
                                value={exercise_details}
                                onChange={onDetailsChanged}
                            />
                        </div>
                    </div>

                    <div className="row mb-3 mt-5">
                        <div className="col-md-12 text-end">
                            <span
                                role="button"
                                className="text-success p-2 icon"
                                title="Save"
                                onClick={onSaveExerciseClicked}
                            >
                                Save Exercise
                                <FontAwesomeIcon icon={faSave}  className="fa-icon"/>
                            </span>
                        </div>
                    </div>
                </form>

            </main>
        </section>
    )

    return content
}
export default NewExerciseForm